import { useCallback, useState } from 'react';
import { SortKey } from '../procountorInvoiceHelpers';

type UseInvoiceListControlsArgs = {
    onFilterChange: () => void;
};

type UseInvoiceListControlsResult = {
    searchText: string;
    statusFilter: string;
    validityFilter: string;
    sortKey: SortKey;
    sortDirection: 'asc' | 'desc';
    setSearchText: (value: string) => void;
    setStatusFilter: (value: string) => void;
    setValidityFilter: (value: string) => void;
    handleSortChange: (nextSortKey: SortKey) => void;
};

export function useInvoiceListControls({ onFilterChange }: UseInvoiceListControlsArgs): UseInvoiceListControlsResult {
    const [searchText, setSearchTextState] = useState('');
    const [statusFilter, setStatusFilterState] = useState('1');
    const [validityFilter, setValidityFilterState] = useState('all');
    const [sortKey, setSortKey] = useState<SortKey>('createdAt');
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');

    const setSearchText = useCallback(
        (value: string) => {
            setSearchTextState(value);
            onFilterChange();
        },
        [onFilterChange]
    );

    const setStatusFilter = useCallback(
        (value: string) => {
            setStatusFilterState(value);
            onFilterChange();
        },
        [onFilterChange]
    );

    const setValidityFilter = useCallback(
        (value: string) => {
            setValidityFilterState(value);
            onFilterChange();
        },
        [onFilterChange]
    );

    const handleSortChange = useCallback(
        (nextSortKey: SortKey) => {
            if (sortKey === nextSortKey) {
                setSortDirection((currentSortDirection) => (currentSortDirection === 'asc' ? 'desc' : 'asc'));
                return;
            }

            setSortKey(nextSortKey);
            setSortDirection(nextSortKey === 'createdAt' ? 'desc' : 'asc');
        },
        [sortKey]
    );

    return {
        searchText,
        statusFilter,
        validityFilter,
        sortKey,
        sortDirection,
        setSearchText,
        setStatusFilter,
        setValidityFilter,
        handleSortChange
    };
}
